import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
} from '@material-ui/core';
import ReviewCard from './ReviewCard';
import BaseButton from './BaseButton';
import {
  selectGuest,
  selectReviewList,
  getReviewList,
} from '../../store/widgetSlice';
import {
  setMessage,
} from '../../store/authSlice';

const useStyles = makeStyles(() => ({
  reviewList: {
    padding: 0,
    margin: 0,
    listStyle: 'none',

    '& li': {
      display: 'none',

      '&:nth-child(-n+3)': {
        display: 'list-item',
      },
    },
  },
  showMore: {
    '& li:nth-child(n)': {
      display: 'list-item',
    },
  },
  elementHidden: {
    display: 'none',
  },
}));

export default function ReviewCardList({ open }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const guest = useSelector(selectGuest);
  const reviewList = useSelector(selectReviewList);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (open && guest && guest.id) {
      dispatch(getReviewList({ guestId: guest.id }))
        .unwrap()
        .then(() => {
          dispatch(setMessage({ message: 'Review list retrieved', severity: 'success' }));
        })
        .catch(() => {
          dispatch(setMessage({ message: 'Review list could not be retrieved', severity: 'error' }));
        });
    }
  }, [dispatch, guest, open]);

  const handleClick = (event) => {
    event.preventDefault();
    setShowMore(!showMore);
  };

  return (
    <>
      <ul className={clsx(classes.reviewList, showMore && classes.showMore)}>
        {reviewList && reviewList.map((review) => (
          <li><ReviewCard review={review} /></li>
        ))}
      </ul>
      <Box
        className={clsx(
          reviewList && reviewList.length <= 3 && classes.elementHidden,
          reviewList && reviewList.length > 3 && classes.showMore,
        )}
        my={2}
        align="center"
        onClick={handleClick}
      >
        <BaseButton>{(showMore) ? 'Show Less' : 'Show More'}</BaseButton>
      </Box>
    </>
  );
}
